<template>
<div>
    <v-snackbar
      timeout="1500"
      top
      style="text-align:center"
      color="#c56060"
      v-model="snackbar"
    >
        {{snackInfo}}
    </v-snackbar>
  <div class="wrapper">
      <input type="text" class="input" placeholder="请手动输入你的愿望，不超过20字" v-model="wish">
      <img src="../../assets/modal/confirm2.png" alt="" class="button"  @click="confirm">
  </div>
  
</div>
</template>

<script>
export default {
    name: 'wishComment',
    data() {
        return {
            wish: '',
            snackbar: false,
            snackInfo: ''
        }
    },
    methods: {
       confirm() {
           if (this.wish.length > 20) {
               this.showSnack('请输入不多于20字的愿望')
               return
           }
            this.$emit('wishComment-confirm', this.wish)
       },
       showSnack(s) {
           this.snackbar = true
           this.snackInfo = s
       }
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    width: 88.89vw;
    margin: 0 auto;
    margin-top: 8vw;
    min-height: 80.56vw;
    background-image: url("../../assets/modal/comment.png");
    background-size: 100% 100%;
    overflow: hidden;
    .input {
        width: 90%;
        margin: 28vw auto 0;
        display: block;
        height: 30vw;
        color: white;
        background-color: #247d43;
        padding: 2vw;
        box-sizing: border-box;
        border-radius: 20px;
        outline: none;
    }
    .input::placeholder {
        color: white;
    }
    .button {
        width: 33.15vw;
        margin: 8vw auto 0;
        display: block;
    }
}

</style>